module.exports = __webpack_public_path__ + "img/leftTop.98db51a3.png";